import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { DocumentFormComponent } from '../document-form/document-form.component';
import { DataService } from 'src/app/shared/services/data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NGXLogger } from 'ngx-logger';
import { Api } from 'src/app/shared/constants/api';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { IDocumentMasterCriteria } from '../document.interface';

@Component({
    selector: 'app-document-view',
    templateUrl: './document-view.component.html',
    styleUrls: ['./document-view.component.less'],
    standalone: false
})
export class DocumentViewComponent implements OnInit, AfterViewInit {
  documentMasterForm: FormGroup;
  displayedColumns=['code','name','action']
  documentDataSource = new MatTableDataSource<IDocumentMasterCriteria>();
	pageSizeOptions:Array<number>=this.utilityService.getPageSizeOptions();
  totalDocumentRecords:any;
	@ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  criteria: IDocumentMasterCriteria = {};


  constructor(private utilityService:UtilityService,
              private formBuilder: FormBuilder,
              private dialog: MatDialog,
              private service: DataService,
              private spinner:NgxSpinnerService,
              private logger:NGXLogger,  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.codeValueChangeEvent();
    this.nameValueChangeEvent();
    this.getDocument();
  }

  ngAfterViewInit() {
  this.documentDataSource.paginator = this.paginator;
  this.documentDataSource.sort = this.sort;
  this.paginator?.page?.pipe(tap(() => this.getDocument())).subscribe();
		this.getDocument();
}


  openForm(row?: any): void{
    const dailogRef =  this.dialog.open(DocumentFormComponent, { data: row });
    dailogRef.afterClosed().subscribe(() => this.getDocument());
  }

  nameValueChangeEvent(){
    this.documentMasterForm.get('name').valueChanges.subscribe(documentName => {
      this.criteria['name']=documentName;
      this.logger.info("INFO NAME", this.criteria);
      this.getDocument();
    })
  }

  codeValueChangeEvent(){
    this.documentMasterForm.get('code').valueChanges.subscribe(documentName => {
      this.criteria['code']=documentName;
      this.getDocument();
      })
  }

  private initializeForm(){
    this.documentMasterForm = this.formBuilder.group({
      code:[null],
      name: [null],
    });
  }

  private getDocument(){
    this.criteria.sort=this.criteria.sort?.length === undefined ? ['createdDate','desc']:this.criteria.sort;
		this.criteria.page=this.paginator?.pageIndex;
    this.criteria.size=this.paginator?.pageSize;
    this.criteria.isDeleted = false;
    this.service.get(Api.DOCUMENT_MASTER, this.criteria).subscribe(res => {
      if(res){
        this.logger.info('Document Response: ',res);
        this.documentDataSource=res.contents;
        this.totalDocumentRecords=res.totalRecords; 
      }
		});
  }

sortData(event: { active: string; direction: string; }){
	this.criteria.sort = [event.active, event.direction];
	this.getDocument();
}

get code() { return this.documentMasterForm.get('code'); }
get name() { return this.documentMasterForm.get('name'); }

}
